import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getUser } from "../redux/features/auth/authService";
import { selectUserDetails } from "../redux/features/auth/authSlice";
import GridLoader from "react-spinners/GridLoader";

const RedirectRoute = ({ children, roleRedirects }) => {
  const { roleName, isLoggedIn, isUserDetailsLoading, hasCheckedAuth } =
    useSelector(selectUserDetails);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasCheckedAuth) {
      dispatch(getUser());
    }
  }, [dispatch, hasCheckedAuth]);

  if (isUserDetailsLoading || !hasCheckedAuth) {
    return <div className={`loader-style`}>
      <GridLoader color="#1D0C50" />
    </div>;
  }

  if (isLoggedIn) {
    const redirectPath = roleRedirects[roleName] || "/";
    return <Navigate to={redirectPath} />;
  }

  return children;
};

export default RedirectRoute;
